// import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {apolloClient} from "./apollo";
import {ApolloProvider} from "@apollo/client";
import {BrowserRouter} from "react-router-dom";
import {theme} from "./theme";
import {ThemeProvider} from "@mui/material";
import "./translations/i18n";
import {Provider} from "react-redux";
import store from "./store/store";
import * as Sentry from "@sentry/react";

// Sentry initialization
Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_WEBIFRAME_DSN,
    debug: true,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
    release: "1.0.3",
    
    // Enable source maps
    attachStacktrace: true,
    
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    
    // Performance Monitoring
    tracesSampleRate: import.meta.env.VITE_SENTRY_SAMPLE_RATE ?
        parseFloat(import.meta.env.VITE_SENTRY_SAMPLE_RATE) : 1.0,
    
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

console.log("VITE_SENTRY_WEBIFRAME_DSN: ", import.meta.env.VITE_SENTRY_WEBIFRAME_DSN);
console.log("VITE_SENTRY_ENVIRONMENT: ", import.meta.env.VITE_SENTRY_ENVIRONMENT);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <BrowserRouter>
        <ApolloProvider client={apolloClient}>
            <ThemeProvider theme={theme}>
                <Provider store={store}>
                    <Sentry.ErrorBoundary fallback={<p>Ein unerwarteter Fehler ist aufgetreten.</p>}>
                        <App />
                    </Sentry.ErrorBoundary>
                </Provider>
            </ThemeProvider>
        </ApolloProvider>
    </BrowserRouter>
);